"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _ = require("../../..");

var _mobxReact = require("mobx-react");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

require("./ExpandableHeader.css");

var _styles = {
  "container": "ExpandableHeader__container___3uU8p",
  "edit-mode": "ExpandableHeader__edit-mode___1IBms",
  "actions": "ExpandableHeader__actions___3eey9",
  "done-check": "ExpandableHeader__done-check___1YAEP"
};

const styles = _bind.default.bind(_styles);

const ExpandableHeader = (0, _mobxReact.observer)(({
  className,
  title,
  subtitle,
  showAnswerAsSubtitle,
  status = 'success',
  statusLabel = 'Done',
  editMode,
  setEditMode,
  dataTestId,
  fontSize = 18,
  labelText = 'Edit'
}) => {
  const composed_classname = (0, _bind.default)(styles('container', {
    'edit-mode': editMode
  }), className);
  return _react.default.createElement(_.Content, {
    className: composed_classname,
    paddingTopBottom: 16,
    paddingLeftRight: 24,
    flex: true,
    justifyContent: 'space-between',
    dataTestId: dataTestId
  }, _react.default.createElement("div", {
    className: styles('info')
  }, _react.default.createElement(_.Text, {
    text: title,
    size: fontSize,
    variant: 'medium'
  }), _react.default.createElement(_.Text, {
    text: showAnswerAsSubtitle ? showAnswerAsSubtitle : subtitle,
    color: _.Color.neutral._80
  })), editMode && status === 'warning' && _react.default.createElement(_.Content, {
    gap: 8,
    flex: true,
    alignItems: 'center'
  }, _react.default.createElement(_.Icon, {
    name: _.IconEnum.exclamation_triangle,
    color: _.Color.semantic.$warning50
  }), _react.default.createElement(_.Text, {
    color: _.Color.semantic.$warning50
  }, statusLabel)), !editMode && _react.default.createElement("div", {
    className: styles('actions'),
    onClick: () => setEditMode(true),
    "data-testid": `button-${dataTestId}`
  }, _react.default.createElement(_.FontAwesome, {
    name: 'pen',
    size: 14,
    color: _.Color.blue._60
  }), _react.default.createElement(_.Text, {
    text: labelText,
    variant: 'medium',
    color: _.Color.blue._60
  })));
});
var _default = ExpandableHeader;
exports.default = _default;